import React from "react";
import PropTypes from "prop-types";
import ClipboardButton from "react-clipboard.js";
import { Modal } from "components/common/modal";
import { Button } from "components/common/button";
import styles from "components/documents/share-url-modal.scss";
import { isValidValue } from "utils/validators";

export const ShareUrlModal = (props) => (
  <Modal
    isVisible={ props.isShareUrlVisible }
    onClose={ props.onHideShareUrl }
    transitionName={ "share-url" }
  >
    {renderShareUrlOrGenerator(props)}
  </Modal>
);

ShareUrlModal.propTypes = {
  isShareUrlVisible: PropTypes.bool.isRequired,
  onHideShareUrl: PropTypes.func.isRequired
};

const renderShareUrlOrGenerator = (props) => {
  if (isValidValue(props.shareUrl) || isValidValue(props.generatedShareUrl)) {
    return <ShareUrl { ...props } />;
  }
  return <GenerateShareUrl { ...props } />;
};

renderShareUrlOrGenerator.propTypes = {
  generatedShareUrl: PropTypes.string.isRequired,
  shareUrl: PropTypes.string.isRequired
};

const ShareUrl = ({ generatedShareUrl, onHideShareUrl, onSetFlashMessage, shareUrl }) => (
  <div>
    <h3>Copy the link below to share this document!</h3>
    <input className={ styles.link } readOnly value={ generatedShareUrl || shareUrl } />
    <div className={ styles.buttons }>
      <Button link onClick={ onHideShareUrl }>cancel</Button>
      <ClipboardButton
        className={ styles["copy-button"] }
        data-clipboard-text={ generatedShareUrl || shareUrl }
        onClick={ () => { onHideShareUrl(); onSetFlashMessage("URL is copied to clipboard"); } }
      >
        Copy to Clipboard
      </ClipboardButton>
    </div>
  </div>
);

ShareUrl.propTypes = {
  generatedShareUrl: PropTypes.string.isRequired,
  onHideShareUrl: PropTypes.func.isRequired,
  onSetFlashMessage: PropTypes.func.isRequired,
  shareUrl: PropTypes.string.isRequired
};

const GenerateShareUrl = ({ accountId, documentId, onHideShareUrl, onGenerateShareUrl }) => (
  <div>
    <h3>Generate a share URL!</h3>
    <div className={ styles.buttons }>
      <Button link onClick={ onHideShareUrl }>cancel</Button>
      <Button onClick={ () => onGenerateShareUrl(accountId, documentId) } primary>
        Generate Share URL
        </Button>
    </div>
  </div>
);

GenerateShareUrl.defaultProps = {
  documentId: ""
};

GenerateShareUrl.propTypes = {
  accountId: PropTypes.string.isRequired,
  documentId: PropTypes.string,
  onGenerateShareUrl: PropTypes.func.isRequired,
  onHideShareUrl: PropTypes.func.isRequired
};



// WEBPACK FOOTER //
// ./src/js/components/documents/modals/share-url-modal.jsx